import React from 'react';
import { observer } from 'mobx-react-lite';

import useStores from 'hooks/useStores';

import { FileType } from 'stores/file_store';
import { EmailProps, EmailHistoryType } from 'stores/email_store';
// type EmailType = {
//     key: string;
//     type: string;
// };

type EmailContextType = {
    sendEmail: (
        workKey: string,
        associated_type: string,
        associated_uuid: string,
        to_email: string,
        from_email: string,
        subject: string,
        content: string,
        files: FileType[]
    ) => Promise<EmailProps | null>;
    fetchList: (
        workKey: string,
        associated_type: string,
        associated_uuid: string
    ) => Promise<EmailProps[]>;

    fetchHistory: (
        workKey: string,
        email: string,
        cursor?: string
    ) => Promise<EmailHistoryType[]>;

    getEmailByAssociation: (
        associated_type: string,
        associated_uuid: string
    ) => EmailProps[];

    resendEmail: (
        workKey: string,
        email: string
    ) => Promise<EmailProps | null>;
}

export const EmailContext = React.createContext<EmailContextType>({
    sendEmail: () => { throw "not implemented, sendEmail" },
    fetchList: () => { throw "not implemented, fetchList" },
    getEmailByAssociation: () => { throw "not implemented, getEmailByAssocation" },
    resendEmail: () => { throw "not implemented, resendEmail" },
    fetchHistory: () => { throw "not implemented, fetchHistory" }
});


export const EmailProvider = observer(({ children }: { children: React.ReactNode }) => {
    const { emailStore } = useStores();

    async function fetchList(workKey: string, associated_type: string, associated_uuid: string) {
        return await emailStore.fetchList(workKey, associated_type, associated_uuid);
    }

    function getEmailByAssociation(associated_type: string, associated_uuid: string) {
        return emailStore.items.filter((email) => {
            return email.associated_type === associated_type && email.associated_uuid === associated_uuid;
        });
    }

    function resendEmail(workKey: string, email: string) {
        return emailStore.resendEmail(workKey, email);
    }

    function fetchHistory(workKey: string, email: string, cursor="") {
        return emailStore.fetchHistory(workKey, email, cursor);
    }


    const data = {
        sendEmail: emailStore.sendEmail,
        fetchList,
        getEmailByAssociation,
        resendEmail,
        fetchHistory
    };

    return (
        <EmailContext.Provider value={data}>{ children }</EmailContext.Provider>
    );

});
